package com.daytimegaming.ourdailyfinances.domain.model

data class Budget(
    val budgetId: String,
    val name: String,
    val categories: List<String>,
    val targetValue: Double,
    val createdAt: String,
    val lastUpdatedAt: String?,
    val lastUpdatedByUserId: String?,
    val createdByUserId: String,
    val dashboardIds: List<String>,
)
